module.exports = __webpack_public_path__ + "img/3_5_tonnes.b545e4d8.png";